import React, { Component } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware, compose, combineReducers } from 'redux';
import thunk from 'redux-thunk';

import AppFrameLayout from '../global/app_frame/app_frame_layout';
import appFrameReducer from '../global/app_frame/app_frame_reducer';
import usersReducer from '../global/user/user_reducer';
import organizationReducer from '../global/organization/organization_reducer';

import SubNav from './sub_nav/sub_nav';
import ThemesLayout from './themes/themes_layout';

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const rootReducer = combineReducers({
    app_frame: appFrameReducer,
    user: usersReducer,
    organization: organizationReducer,
});

const store = createStore(rootReducer, composeEnhancers(
    applyMiddleware(thunk)
));

class ThemesApp extends Component {
    render() {
        return (
            <Provider store={store}>
                <BrowserRouter>
                    <AppFrameLayout>
                        <SubNav />
                        <ThemesLayout />
                    </AppFrameLayout>
                </BrowserRouter>
            </Provider>
        );
    }
}

export default ThemesApp;
